import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages cart functionality.
 * Upon adding an item, it redirects the user to the cart page.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * Handles the cart add event by redirecting the user to the cart page.
   */
  #handleCartAdd = () => {
    window.location.href = '/cart';
  };

  /**
   * This method would typically open the cart drawer, but since the component
   * now redirects, it may have limited use unless called directly.
   */
  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs.
     * This logic is kept in case the drawer is opened by other means.
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  /**
   * Closes the dialog.
   */
  close() {
    this.closeDialog();
  }
}

// Define the custom element if it hasn't been defined already.
if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}